import type { Module, ModuleOptionsValue } from '@/modules/companies/consts'
import React from 'react'
import styled from 'styled-components'
import { useModuleConfig } from '@/utils/hooks'
import { OptionToggle } from './OptionToggle'

const Wrapper = styled.div`
  & > div + div {
    margin-top: 2rem;
  }
`

export const ModuleOptionCards: React.JSX.CFC<{
  module: Module
  includeOptions?: ModuleOptionsValue[] // If provided, only these options will be included. Otherwise, all options for the module will be included.
}> = ({ module, includeOptions }) => {
  const { moduleOptions } = useModuleConfig(module)

  const visibleOptions = includeOptions
    ? moduleOptions.filter(option =>
        includeOptions.includes(option.name as ModuleOptionsValue)
      )
    : moduleOptions

  return (
    <Wrapper>
      {visibleOptions.map(option => (
        <OptionToggle key={option.id} option={option} />
      ))}
    </Wrapper>
  )
}
